import React, { FC, useRef } from 'react';
import { ItemProps } from './models';

const Item: FC<ItemProps> = ({
  menu,
  setactiveSubNav,
  setactiveSecondSubNav,
  setOffSetLeft,
}) => {
  const refCurrentItem = useRef<HTMLLIElement | null>(null);

  return (
    <li
      ref={refCurrentItem}
      className="main-nav__item"
      onClick={() => {
        setactiveSecondSubNav(null);
        menu.children.length && setactiveSubNav(menu.children);
        refCurrentItem?.current?.offsetLeft &&
          setOffSetLeft(refCurrentItem.current.offsetLeft);
      }}
    >
      {menu.name}
    </li>
  );
};

export default Item;
